<template>
    <div class="container-fluid mt-5">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-6">
                <h3 class="mb-0">Operadores</h3>
              </div>
              <div class="col-6 text-right">
                <base-button class="hover-apolo" type="default" icon size="sm" @click="showAddModal = true">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Operador</span>
                </base-button>
              </div>
            </div>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
            <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Datos por página"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item.value"
                  :label="item.descripcion"
                  :value="Number(item.value)"
                >
                </el-option>
            </el-select>

              <div>
                <form class="apolo-borde">
                  <base-input
                    v-model="search"
                    type="search"
                    append-icon="fas fa-search"
                    placeholder="Buscar..."
                    clearable
                    inputClasses="apolo-borde"
                  />
                </form>
              </div>

              <el-select
                class="select-primary pagination-select"
                v-model="status"
                placeholder="Seleccionar status"
                clearable
              >
                <el-option
                  class="select-primary"
                  label="Activo/Inactivo"
                  value="Activo/Inactivo"
                >
                </el-option>
                <el-option
                  class="select-primary"
                  label="Activo"
                  value="Activo"
                >
                </el-option>
                <el-option
                  class="select-primary"
                  label="Inactivo"
                  value="Inactivo"
                >
                </el-option>
              </el-select>
            </div>
            <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="operadores"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>

              <div slot="empty" v-if="operadores">
                Sin datos disponibles
              </div>
  
              <el-table-column label="Nombre">
                <div slot-scope="{ row }" class="table-actions">
                  <span>{{row.attributes.nombre}} {{row.attributes.apellidos}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Número licencia">
                <div slot-scope="{ row }" class="table-actions">
                  <span>{{row.attributes.numero_licencia}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Vigencia licencia">
                <div slot-scope="{ row }">
                  <span v-if="checkDate(row.attributes.vigencia_licencia)" style="color: red !important;">{{row.attributes.vigencia_licencia | moment('DD-MM-YYYY')}}</span>
                  <span v-else>{{row.attributes.vigencia_licencia | moment('DD-MM-YYYY')}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Vigencia apto médico">
                <div slot-scope="{ row }">
                  <span v-if="checkDate(row.attributes.vigencia_apto_medico)" style="color: red !important;">{{row.attributes.vigencia_apto_medico | moment('DD-MM-YYYY')}}</span>
                  <span v-else>{{row.attributes.vigencia_apto_medico | moment('DD-MM-YYYY')}}</span>
                </div>
              </el-table-column>
              <el-table-column align="center">
                <div slot-scope="{ row }" class="table-actions">
                  <base-button class="hover-apolo" type="primary" icon size="sm" @click="editOperador(row)">
                    <span class="btn-inner--text">Editar</span>
                  </base-button>
                  <base-button v-if="row.attributes.active" class="hover-apolo" type="primary" icon size="sm" @click="deactivateOperador(row)">
                    <span class="btn-inner--text">Desactivar</span>
                  </base-button>
                  <base-button  v-else class="hover-apolo" type="primary" icon size="sm" @click="activateOperador(row)">
                    <span class="btn-inner--text">Activar</span>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center flex-wrap"
          >
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </div>
        </card>
      </div>
      <!-- MODAL CREATE -->
      <modal :show.sync="showAddModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Crear operador</h6>
        <form class="new-event--form" @submit.prevent="addOperador">
          <base-input label="Nombre"
                      placeholder="Nombre del operador"
                      v-model="operador.nombre"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.nombre" />
          <base-input label="Apellidos"
                      placeholder="Apellidos del operador"
                      v-model="operador.apellidos"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.apellidos" />
          <base-input label="Número de licencia"
                      placeholder="Número de licencia"
                      v-model="operador.numero_licencia"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.numero_licencia" />
          <base-input label="Vigencia de licencia">
            <date-picker
              v-model="operador.vigencia_licencia"
              :format="'DD-MM-YYYY'"
              :lang="'es'"
            ></date-picker>
          </base-input>
          <validation-error :errors="apiValidationErrors.vigencia_licencia" />
          <base-input label="Vigencia apto médico">
            <date-picker
              v-model="operador.vigencia_apto_medico"
              :format="'DD-MM-YYYY'"
              :lang="'es'"
            ></date-picker>
          </base-input>
          <validation-error :errors="apiValidationErrors.vigencia_apto_medico" />
          <br>
          <span>Opcionales:</span>
          <base-input label="Celular"
                      placeholder="Celular"
                      v-model="operador.celular"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <base-input label="Celular patrón"
                      placeholder="Celular patrón"
                      v-model="operador.celular_patron"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <base-input label="Nombre patrón"
                      placeholder="Nombre patrón"
                      v-model="operador.nombre_patron"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="addOperador">Guardar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL EDIT -->
      <modal :show.sync="showEditModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Editar operador</h6>
        <form class="new-event--form" @submit.prevent="updateOperador">
          <base-input label="Nombre"
                      placeholder="Nombre del operador"
                      v-model="operador.nombre"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.nombre" />
          <base-input label="Apellidos"
                      placeholder="Apellidos del operador"
                      v-model="operador.apellidos"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.apellidos" />
          <base-input label="Número de licencia"
                      placeholder="Número de licencia"
                      v-model="operador.numero_licencia"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.numero_licencia" />
          <base-input label="Vigencia de licencia">
            <date-picker
              v-model="operador.vigencia_licencia"
              :format="'DD-MM-YYYY'"
              :lang="'es'"
            ></date-picker>
          </base-input>
          <validation-error :errors="apiValidationErrors.vigencia_licencia" />
          <base-input label="Vigencia apto médico">
            <date-picker
              v-model="operador.vigencia_apto_medico"
              :format="'DD-MM-YYYY'"
              :lang="'es'"
            ></date-picker>
          </base-input>
          <validation-error :errors="apiValidationErrors.vigencia_apto_medico" />
          <br>
          <span>Opcionales:</span>
          <base-input label="Celular"
                      placeholder="Celular"
                      v-model="operador.celular"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <base-input label="Celular patrón"
                      placeholder="Celular patrón"
                      v-model="operador.celular_patron"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <base-input label="Nombre patrón"
                      placeholder="Nombre patrón"
                      v-model="operador.nombre_patron"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="updateOperador">Actualizar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
    </div>
  </template>
  <script>
  import formMixin from "@/mixins/form-mixin";
  import ValidationError from "@/components/ValidationError.vue";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import { BasePagination, Modal } from "@/components/";
  import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
  } from "element-ui";
  import swal from "sweetalert2";
  import "sweetalert2/dist/sweetalert2.css";
  
  export default {
    layout: "DashboardLayout",
  
    components: {
      Modal,
      DatePicker,
      ValidationError,
      BasePagination,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      [Button.name]: Button,
    },

    mixins: [formMixin],
  
    data() {
      return {
        operadores: [],
        selectedRows: [],

        status: null,
        search: null,
  
        sort: "created_at",
  
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [{value:'5', descripcion: '5 operadores por página'},
          {value:'10', descripcion: '10 operadores por página'},
          {value:'25', descripcion: '25 operadores por página'},
          {value:'50', descripcion: '50 operadores por página'}],
        },
        total: 0,
        loading: true,
        showAddModal: false,
        showEditModal: false,
        operador: {
          type: "operador",
          nombre: null,
          apellidos: null,
          numero_licencia: null,
          vigencia_licencia: null,
          vigencia_apto_medico: null,
          celular: null,
          celular_patron: null,
          nombre_patron: null,
        }
      };
    },
  
    computed: {
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
  
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
    },
  
    watch: {
      search: {
        handler: "getListDebounced",
        immediate: true,
      },
      status: {
        handler: "getListDebounced",
        immediate: true,
      },
      pagination: {
        handler: "getList",
        immediate: false,
        deep: true,
      },
    },

    mounted(){
      //const date = new Date();
      //this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    },
  
    methods: {
      getListDebounced: _.debounce(function () {
        this.getList();
      }, 300),
  
      async getList() {
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.search ? { nombre: this.search } : {}),
            ...(this.status ? { status: this.status } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };
        await this.$store.dispatch("operadores/list", params).then(() => {
          this.operadores = this.$store.getters["operadores/list"];
          this.total = this.$store.getters["operadores/listTotal"];
        });
        this.loading = false;
      },

      checkDate(date){
        var now = new Date();

        var dateControl = date.split('-');
        dateControl = new Date(dateControl[0], dateControl[1]-1, dateControl[2]);
      
        if (dateControl < now 
            || (now.getMonth()+1) === (dateControl.getMonth()+1) && ((dateControl.getFullYear()) <= (now.getFullYear()))
            || ((dateControl.getMonth()+1)-(now.getMonth()+1)) === 1 && ((dateControl.getFullYear()) <= (now.getFullYear())) && ((dateControl.getDate()) - (now.getDate())) <= 0) {
          return true;
        } else {
          return false;
        }
      },

      closeModal() {
        if(this.showAddModal == true){
          this.showAddModal = false;
        }else{
          this.showEditModal = false;
        }
        this.resetApiValidation();
        this.operador.nombre = null;
        this.operador.apellidos = null;
        this.operador.numero_licencia = null;
        this.operador.vigencia_licencia = null;
        this.operador.vigencia_apto_medico = null;
        this.operador.celular = null;
        this.operador.celular_patron = null;
        this.operador.nombre_patron = null;
      },

      async addOperador(){
        try {
        await this.$store.dispatch("operadores/add", this.operador);
        this.$notify({
          type: "success",
          message: "Operador creado satisfactoriamente.",
          duration: -1
        });
        this.getList();
        this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      editOperador(row) {
        this.resetApiValidation();
        this.showEditModal = true;
        this.operador.nombre = row.attributes.nombre;
        this.operador.apellidos = row.attributes.apellidos;
        this.operador.numero_licencia = row.attributes.numero_licencia;
        const dateLicencia = row.attributes.vigencia_licencia.split('-');
        this.operador.vigencia_licencia = new Date(dateLicencia[0],dateLicencia[1]-1,dateLicencia[2]);
        this.operador.vigencia_apto_medico = row.attributes.vigencia_apto_medico;
        const dateApto = row.attributes.vigencia_apto_medico.split('-');
        this.operador.vigencia_apto_medico = new Date(dateApto[0],dateApto[1]-1,dateApto[2]);
        this.operador.celular = row.attributes.celular;
        this.operador.celular_patron = row.attributes.celular_patron;
        this.operador.nombre_patron = row.attributes.nombre_patron;
        this.operador.id = row.id;
      },

      async updateOperador() {
        try{
          await this.$store.dispatch("operadores/update", this.operador);
          this.$notify({
            type: "success",
            message: "Operador actualizado satisfactoriamente.",
            duration: -1
          });
          this.getList();
          this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },
      
      async activateOperador(row) {
        const confirmation = await swal.fire({
          title: `¿Desea activar este operador?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Activar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("operadores/activate", row.id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Operador activado satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        }
      },
      async deactivateOperador(row) {
        const confirmation = await swal.fire({
          title: `¿Desea desactivar este operador?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Desactivar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("operadores/deactivate", row.id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Operador desactivado satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        }
      },

      sortChange({ prop, order }) {
        if (order === "descending") {
          this.sort = `-${prop}`;
        } else {
          this.sort = `${prop}`;
        }
        this.getList();
      },
    },
  };
  </script>